import { Chip as MUIChip } from "@mui/material";

interface IProps {
    value?: any;
    label: string;
    disabled?: boolean;
    onDelete?: (value: any) => void;
}

const Chip: React.FC<IProps> = ({ disabled, onDelete, label, value }: IProps) => (
    <MUIChip
        color="info"
        variant="outlined"
        disabled={disabled}
        onDelete={onDelete}
        label={`${label}: ${value}`}
        sx={{ marginRight: "4px" }}
    />
);

export default Chip;
